import widgetTemplate from '../../templates/widgetTemplate.html';
import DockManager from './DockManager';
import Constants from '../main/Constants';
export default class CustomKendoWindow {

	static CHAT_MSG_NOTSEEN = 1;
	static CHAT_MSG_RECEIVED = 2;
	static CHAT_MSG_SEEN = 3;

    constructor(context, testerIdentifier, testerName) {
		this.context = context;
		this.testerIdentifier = testerIdentifier;
        this.testerName = testerName;
		this.isChatEnabled = false;
		this.videoCallRunning = false;
		this.allowMinimize = true;
		this.isIconHandRaised = false;

        // create chat and video div
		this.windowDiv = $k('<div>').attr('id', 'window-' + testerIdentifier);
		this.chatDiv = $k('<div>').attr('id', 'chatWindow-' + testerIdentifier);
		this.callVideoContainer = $('<div>').attr({'id':'callVideoContainer-'+testerIdentifier,'class':'rtpIcon-no-display rtp_callVideo_div'});
		this.unseenChatCount = 0;

		// add tools, chat, video div to the widget
		this.windowDiv.append(this.addToolsTab(testerIdentifier), this.chatDiv, this.callVideoContainer);

		// add widget to body
		$('body').append(this.windowDiv);

		this.changeVideoLabelToVideo(testerIdentifier);

		//create global variables
		this.createVariables(testerIdentifier);
		// Initiate kendo chat
		this.initiateKendoChat(testerIdentifier);
		this.attachListeners();
		this.windowDiv.addClass('rtp-loading');
		this.windowDiv.append('<i class="fa-solid fa-spinner fa-spin rtp-loading-icon"></i>');
    }

	addToolsTab(testerIdentifier){
		var template =  _.template($(widgetTemplate).filter("#toolsTabContainerTemplate").html());
		return template({testerIdentifier : testerIdentifier, isProctor : this.context.isProctor()});
	}

	createVariables(testerIdentifier){
		this.toolsTab = $k('.toolsTab-container');
		this.chatBtn = $k('#chatBtn-' + testerIdentifier);
		this.endBtn = $k('#toolBarEndBtn_'+ testerIdentifier);
		this.videoBtn = $k('#videoBtn-' + testerIdentifier);
	}

	addTooltips(isProctor){
		let that = this;
		this.handTooltip = this.kendoWindow.wrapper.find('button[aria-label="Hand"]').kendoTooltip({
			content: function(e) {
				if (that.isIconHandRaised) {
					return rtp_i18next.t("generalWords:lowerHand");
				} else {
					if (isProctor) {
						return rtp_i18next.t("generalWords:hand");
					} else {
						return rtp_i18next.t("generalWords:raiseHand");
					}
				}
			},
			position: "bottom"}).data("kendoTooltip");
		this.kendoWindow.wrapper.find('button[aria-label="window-Minimize"]').kendoTooltip({content: rtp_i18next.t("generalWords:minimize") });
		this.kendoWindow.wrapper.find('button[aria-label="unlock"]').kendoTooltip({content: rtp_i18next.t("generalWords:unlock") });
		this.chatDiv.find('button[aria-label="Send message"]').kendoTooltip({ content: rtp_i18next.t("generalWords:sendMessage") });
		this.modifyTooltipsSwitchToChat();
		this.handTooltip.refresh();
	}

	initiateKendoChat(testerIdentifier){
		let that = this;
		this.kendoChat = this.chatDiv.kendoChat({
			sendMessage: function (e) {
				that.textarea.val("");
				that.textarea.trigger('input');
			},
			post: function (e) {
				//The "Post" event is fired by kendo when messages are sent.  When this happens, "e.text" is just a string.  However, we are also explicitely calling "post" for historical records.
				//When we do this, we are passing an object that contains the chat message and the timestamp as "e.text".  This is done so that we can override the timestamp to use the historical message's timestamp rather than the current time.
				if(typeof e.text === 'object') {
					let isHistorical = e.text.historical;
					e.timestamp = new Date(e.text.timestamp);
					e.text = e.text.text;
					if (!isHistorical) {
						let msgId = 'rtpchat-'+e.timestamp;
						that.sendMessageKendoChatHandler(e, testerIdentifier, msgId);
					}
				} else {
					let msgId = 'rtpchat-'+e.timestamp;
					that.sendMessageKendoChatHandler(e, testerIdentifier, msgId);
				}
			}
		}).data("kendoChat");
		CustomKendoWindow.replaceInputWithTextarea(this);
	}

	postBroadcastMsg(message) {
		this.kendoChat.renderMessage({
			type: "broadcast",
			title: rtp_i18next.t('testerWidget:announcement'),
			text: message.data.text,
			timestamp : new Date(message.data.jsonTimestamp)
		},{
			name: rtp_i18next.t("proctorWidget:proctor")
		});

		//Formatting the look of announcement by removing the author name(i.e, broadcast) and 'k-alt' which determines who is sending the message and formatts the message accordingly.
		$('.rtp-broadcast-group').last().siblings('p.k-author').remove();
		$('.rtp-broadcast-group').last().parent()[0].classList.remove("k-alt");
	}

	static replaceInputWithTextarea(context) {
		let originalElement = context.kendoChat.wrapper.find('.k-input-inner');
		let attrs = { };
		$.each(originalElement[0].attributes, function(idx, attr) {
			attrs[attr.nodeName] = attr.nodeValue;
		});
		//create a textarea using the attributes of the original text input
		let newElement = $('<textarea />', attrs).append($(originalElement).contents());
		originalElement.parent().prepend(newElement);
		originalElement.remove();
		newElement.append(originalElement);
		originalElement.hide();
		context.textarea = $k(`#${attrs['id']}`).kendoTextArea({overflow: "auto"});

		const maxRows = 4;
		//don't allow line breaks in the new textarea
		context.textarea.on('keydown', function(e) {
			if (e.which === 13) {
				e.preventDefault();
			}
			if (e.ctrlKey && e.code == 'Enter') {
				// Send message (expanded compose box) - Ctrl+Enter
				context.kendoChat.postMessage(originalElement.val());
				context.kendoChat.trigger('sendMessage', {'text' : originalElement.val()});
			}
		});
		context.textarea.on('input keyup paste', function(e) {
			originalElement.val($(this).val());
			if(e.type === 'keyup' && e.which === 13 && originalElement.val()) {
				//if the 'enter' key is pressed, post/send the message
				context.kendoChat.postMessage(originalElement.val());
				context.kendoChat.trigger('sendMessage', {'text' : originalElement.val()});
				return;
			}
			//https://stackoverflow.com/a/36958094
			let $el = $(this);
			let offset = $el.innerHeight() - $el.height();
			$el.height(1);
			$el.height(Math.min(this.scrollHeight - offset, offset * maxRows));
		});
		//Recalculate the height/scrollbar when the textarea is resized.
		const resizeObserver = new ResizeObserver(entries => {
			const initialSize = context.textarea.get(0).getBoundingClientRect();
			let observer = entries[0];
			$(observer.target).trigger('input');
			const newSize = context.textarea.get(0).getBoundingClientRect();
			if(initialSize.width != newSize.width || initialSize.height != newSize.height) {
				resizeObserver.unobserve(context.textarea.get(0));
				window.requestAnimationFrame(() => {
					resizeObserver.observe(context.textarea.get(0));
				});
			}
		});

		resizeObserver.observe(context.textarea.get(0));
	}

	sendMessageKendoChatHandler(e, testerIdentifier, msgId) {
		//For some reason, the sendMessage event is being triggered twice.  This prevents a double message on the receiving end.
		if(e.sender._events.sendMessage.length == 1) {
			this.context.chat(testerIdentifier, e.text, msgId);
		}
	}

	addKeyboardShortcuts() {
		let pressedKeys = new Set();
		let keyboardCommands = this.getKeyboardCommands();
		let retainableKeys = [Constants.Keys.CONTROL, Constants.Keys.SHIFT, Constants.Keys.ALT];
		//These events are only fired if the window has focus.
		this.kendoWindow.wrapper.on('keydown', (e) => {
			let key = e.key.toLowerCase();
			pressedKeys.add(key);

			keyboardCommands.map((command) => {
				if(command.keys.every(k => pressedKeys.has(k))) {
					//if all of the keys are active, call the function
					command.run();
					//clear the pressed keys, but retain control/alt/shift
					pressedKeys = new Set(Array.from(pressedKeys).filter(k => retainableKeys.includes(k)));
					return;
				}
			});
		});

		this.kendoWindow.wrapper.on('keyup', (e) => {
			let key = e.key.toLowerCase();
			pressedKeys.delete(key);
		});
	}

	attachListeners() {
		this.chatBtn.off('click',this.chatBtnClickHandler.bind(this)).on('click',this.chatBtnClickHandler.bind(this));
		this.videoBtn.off('click',this.videoBtnClickHandler.bind(this)).on('click',this.videoBtnClickHandler.bind(this));
		this.endBtn.off('click').on('click',this.endBtnClickHandler.bind(this));
	}

	chatBtnClickHandler(e) {
		this.switchToChat();
	}

	switchToChat() {
		this.handleSwitchToChatView();
		this.endBtn.removeClass("endCall");
		this.setEndBtnToEndChat();
		if (this.isVideoCallRunning() || this.isAudioCallRunning()) {
			CustomKendoWindow.videoBtnHighlightOn(this.videoBtn);
		} else {
			CustomKendoWindow.videoBtnHighlightOff(this.videoBtn);
		}
	}

	handleSwitchToChatView(){
		RTP.UIUtil.hideElement(this.callVideoContainer);
		RTP.UIUtil.showElement(this.chatDiv);
		RTP.UIUtil.setActiveElement(this.chatBtn);
		RTP.UIUtil.setInActiveElement(this.videoBtn);
		this.deleteChatVideoTooltips();
		this.modifyTooltipsSwitchToChat();
	}

	setEndBtnToEndChat() {
		if(!(this.endBtn.hasClass('rtp-answerCallBtn'))) {
			this.endBtn[0].innerText = rtp_i18next.t("proctorWidget:endChat");
			this.endBtn.removeClass('rtpIcon-no-display');
			this.endBtn.removeClass('endBtn');
			this.endBtn.removeClass('endCallBtn');
			this.endBtn.addClass('endChatBtn');
			this.endBtn.prop("disabled", !this.isChatEnabled);
		}
	}

	modifyTooltipsSwitchToChat(){
		this.chatBtn.kendoTooltip({position: "left" , content: rtp_i18next.t('generalWords:chatModeSelected')});
		const videoBtnTooltipContent = this.videoBtn.hasClass('groupCall')? rtp_i18next.t('generalWords:groupCall'): rtp_i18next.t('videoMonitoring:videoCall');
		this.videoBtn.kendoTooltip({position: "right" , content: videoBtnTooltipContent});
	}

	deleteChatVideoTooltips(){
		this.chatBtn.data("kendoTooltip").destroy();
		this.videoBtn.data("kendoTooltip").destroy();
	}

	videoBtnClickHandler(e) {
		this.switchToVideo();
	}

	switchToVideo() { //TODO-Refactor: This function is being called by both proctor and tester. Need to simplify.
		if (this.context.isSwitchToVideoAllowed(this.testerIdentifier)) {
			this.handleSwitchToCallView();
			this.endBtn.addClass("endCall");
			this.setEndBtnToEndCall();
			CustomKendoWindow.videoBtnHighlightOff(this.videoBtn);
			!this.videoBtn.hasClass("groupCall") && this.context.switchToVideo(this.testerIdentifier, this);
		}
	}

	handleSwitchToCallView(){
		RTP.UIUtil.hideElement(this.chatDiv);
		RTP.UIUtil.setInActiveElement(this.chatBtn);
		RTP.UIUtil.setActiveElement(this.videoBtn);
		this.deleteChatVideoTooltips();
		this.modifyTooltipsSwitchToVideo();
		RTP.UIUtil.showElement(this.callVideoContainer);
	}

	static videoBtnHighlightOff(element) {
		element.removeClass("videoBtnInCall");
	}

	static videoBtnHighlightOn(element) {
		element.addClass("videoBtnInCall");
	}

	setEndBtnToEndCall(){
		if(!(this.endBtn.hasClass('rtp-answerCallBtn'))){
			this.endBtn[0].innerText = rtp_i18next.t("proctorWidget:endCall");
			this.endBtn.removeClass('endBtn');
			this.endBtn.removeClass('endChatBtn');
			this.endBtn.addClass('endCallBtn');
			if(this.endBtn[0].disabled == true){
				this.endBtn.prop("disabled", false);
			}
		}
	}
	modifyTooltipsSwitchToVideo(){
		this.chatBtn.kendoTooltip({position: "left" , content: rtp_i18next.t('generalWords:chat')});
		var videoBtnTooltipContent = this.videoBtn.hasClass('groupCall') ?  rtp_i18next.t('generalWords:groupCallModeSelected') :rtp_i18next.t('generalWords:videoModeSelected');
		this.videoBtn.kendoTooltip({position: "right" , content: videoBtnTooltipContent});
	}

	static changeVideoLabel(element, textToDisplay, inVideoMode) {
		element[0].innerText = textToDisplay;
		if(inVideoMode){
			element.addClass('rtp-redText');
		}else{
			element.removeClass('rtp-redText');
		}
	}

	changeChatStatusIcon(chatIconElement, tooltipElement, chatMessageStatus) {
		if (chatIconElement && tooltipElement) {
			if (tooltipElement.data("kendoTooltip")) {
				tooltipElement.data("kendoTooltip").destroy();
			}
			if (chatMessageStatus == CustomKendoWindow.CHAT_MSG_NOTSEEN) {
				chatIconElement.classList.add('k-i-exclamation-circle');
				tooltipElement.kendoTooltip({ content: rtp_i18next.t("generalWords:notDelivered") });
			} else {
				chatIconElement.classList.remove('k-i-exclamation-circle');
			}
			if (chatMessageStatus == CustomKendoWindow.CHAT_MSG_RECEIVED) {
				chatIconElement.classList.add('k-i-check-outline');
				tooltipElement.kendoTooltip({ content: rtp_i18next.t("generalWords:sent") });
			} else {
				chatIconElement.classList.remove('k-i-check-outline');
			}
			if (chatMessageStatus == CustomKendoWindow.CHAT_MSG_SEEN) {
				chatIconElement.classList.add('k-i-check-circle');
				tooltipElement.kendoTooltip({ content: rtp_i18next.t("generalWords:seen") });
			} else {
				chatIconElement.classList.remove('k-i-check-circle');
			}
			// Set the color of the icon
			if (chatMessageStatus == CustomKendoWindow.CHAT_MSG_RECEIVED || chatMessageStatus == CustomKendoWindow.CHAT_MSG_SEEN) {
				chatIconElement.classList.add('rtp-icon-darkblue');
				chatIconElement.classList.remove('k-color-error');
			} else {
				chatIconElement.classList.remove('rtp-icon-darkblue');
				chatIconElement.classList.add('k-color-error');
			}
		}
	}

	endBtnClickHandler(e){
		if (e.currentTarget.innerText.toLowerCase() == 'end call') {
			if (this.isVideoCallRunning()) {
				this.context.endCall(this.testerIdentifier);
				this.setEndBtnToEndChat();
				this.setVideoCallRunning(false);
				this.context.determineAllStartButtonStatuses(this.testerIdentifier);
			}else{
				CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier), rtp_i18next.t("generalWords:startCall"),false);
				this.changeVideoLabelToVideo(this.testerIdentifier);
			}
			this.switchToChat();
		} else if (e.currentTarget.innerText.toLowerCase() === 'end chat') {
			this.context.postNotificationMsg(rtp_i18next.t("generalWords:chatEnded"), this.testerIdentifier);
			this.context.disableChat(this.testerIdentifier);
		} else {
			console.log("endBtnClickHandler() Unknown State");
		}
	}

	static restoreMinimizeButton(kendoWindow) {
		let minimizeBtn = kendoWindow.wrapper.find('button[aria-label="window-Minimize"]');
		if (minimizeBtn != undefined && minimizeBtn != null) {
			minimizeBtn.show();
			this.allowMinimize = true;
		}
	}

	static hideMinimizeButton(kendoWindow) {
		let minimizeBtn = kendoWindow.wrapper.find('button[aria-label="window-Minimize"]');
		if (minimizeBtn != undefined && minimizeBtn != null) {
			minimizeBtn.hide();
			this.allowMinimize = false;
		}
	}

	static restoreHideButton(kendoWindow){
		let hideBtn = kendoWindow.wrapper.find('button[aria-label="Close"]');
		hideBtn?.show();
	}

	static hideCloseButton(kendoWindow){
		let hideBtn = kendoWindow.wrapper.find('button[aria-label="Close"]');
		hideBtn?.hide();
	}

	isVideoCallRunning() {
		return this.videoCallRunning;
	}

	setVideoCallRunning(videoCallRunning) {
		this.videoCallRunning = videoCallRunning;
	}

	setIsBeingCalled(beingCalled) {
		this.beingCalled = beingCalled;
	}

	isAudioCallRunning(){
		return this.audioCallRunning;
	}

	preventDblClickAndRightClick() {
		let wrapper = this.kendoWindow.wrapper;
		wrapper.find('.k-window-titlebar').dblclick(function(e) {
			e.stopImmediatePropagation();
		});

		wrapper.bind("contextmenu", function(e){
			return false;
		});
	}

	static updateMuteIcon(icon, muted) {
        if(muted) {
            icon.removeClass('fa-microphone');
            icon.removeClass('unMutedMicrophoneIcon');
            icon.addClass('mutedMicrophoneIcon');
            icon.addClass('fa-microphone-slash');
        } else {
            icon.removeClass('fa-microphone-slash');
            icon.removeClass('mutedMicrophoneIcon');
            icon.addClass('unMutedMicrophoneIcon');
            icon.addClass('fa-microphone');
        }
	}

	static clamp(kendoWindow) {
		let currentPosition = kendoWindow.options.position;
		let left = DockManager.clamp(currentPosition.left, 0, window.innerWidth - parseInt(kendoWindow.options.width, 10));
		let top = DockManager.clamp(currentPosition.top, 0, window.innerHeight - parseInt(kendoWindow.wrapper.innerHeight(), 10));
		DockManager.updateWindowPosition(kendoWindow, left, top);
	}
}
